module.exports = __webpack_public_path__ + "img/mombaby.4419cd98.png";